<template>
    <div class="topbar-container">
        <div class="scrollbar-container">
            <validation-observer v-slot="{ invalid }">
                <div class="topImg bg-contain">
                    <div class="c_white fz_28">会员账号({{ parms.name }})</div>
                    <validation-provider
                        :name="rulesParms.numberTypeStr"
                        :rules="`${idRex}|required`"
                        v-slot="{ errors }"
                    >
                        <van-field
                            class="field vipPlaceholder"
                            type="tel"
                            clearable
                            v-model="number"
                            :maxlength="numberMax"
                            :placeholder="`请输入注册的${ parms.name }${rulesParms.numberTypeStr}(必填)`"
                        >
                            <zb-warning class="warning" slot="right-icon" :message="errors[0]" />
                        </van-field>
                    </validation-provider>
                </div>
                <div class="list-container">
                    <div class="list correct-list r10 shadow-bg">
                        <validation-provider :rules="{required: { allowFalse: false } }">
                            <input type="hidden" v-model="goodsId" />
                        </validation-provider>
                        <div class="fz_34 title">充值面额</div>
                        <div class="bh bwrap">
                            <div
                                class="list-item"
                                :class="{'correct-active' :goodsId == item.id}"
                                v-for="(item, index) in store.data"
                                :key="index"
                                @click="changeIndex(item.id)"
                            >
                                <div class="item">
                                    <div class="item-el bv bc">
                                        <div class="c_333 fz_30">{{item.name}}</div>
                                        <div>
                                            <span class="c_warning fz_40">￥{{item.price}}&nbsp;</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="bh bc">
                            <van-button
                                :disabled="invalid"
                                @click="onBuyClick"
                                class="btn btn-buy"
                            >确认兑换</van-button>
                        </div>
                    </div>
                </div>
            </validation-observer>
        </div>
    </div>
</template>

<script>
import { routeCache } from "@/mixin/cache";
import { user } from "@/mixin/user";
import { list } from "@/mixin/list";
import { vipList, vipTypeInfo, vipSave } from "@/api/fee";
import { saveOrder } from "@/api/cart";
export default {
    mixins: [routeCache, user, list],
    data() {
        return {
            // 页面参数
            parms: {},
            // 服务端校验规则
            rulesParms: {},
            // 用户编码 验证规则
            idRex: "",
            // 用户编码
            number: "",
            // 商品id
            goodsId: "",
            // 账号最大输入数量
            numberMax: 15,
            store: {
                proxy: {
                    getList: vipList
                }
            }
        };
    },
    methods: {
        // 获取数据后执行
        userLoginend() {
            const me = this,
                // 获取页面参数
                parms = me.getCache(),
                // 商品类型id
                id = parms.id;
            // 设置标题
            me.$store.state.topBarTitle = parms.name;
            me.parms = parms;
            // 加载商品列表
            me.storeLoad({
                cateId: id
            });
            // 获取校验规则
            vipTypeInfo(id).then(res => {
                me.rulesParms = res.data;
                const data = res.data,
                    numberType = data.numberType;
                // 0 手机号码 1 QQ号码 2 uid
                me.idRex = ["mobile", "positiveInteger", "positiveInteger"][
                    numberType
                ];
                // 账号最大输入数量
                me.numberMax = [11, 10, 15][numberType];
                console.log(me.numberMax);
            });

            // 测试环境处理
            if (me.$store.state.isDev) {
                me.number = "18784012064";
            }
        },
        // 选中商品
        changeIndex(id, index) {
            this.goodsId = id;
        },
        onBuyClick() {
            const me = this;
            me.dialog
                .confirm(
                    {
                        title: "温馨提示",
                        message: `确认给账号${me.number}充值吗？`,
                        confirmButtonText: "确定",
                        cancelButtonText: "取消"
                    },
                    true
                )
                .then(() => {
                    // 获取用户id
                    vipSave({
                        appType: me.rulesParms.appType,
                        numberType: me.rulesParms.numberType,
                        number: me.number
                    }).then(res => {
                        // 生成订单
                        saveOrder({
                            // 用户id
                            customerMemberNumberId: res.data,
                            fromCart: false,
                            // 商品信息
                            prepayGoodsList: [
                                {
                                    goodsId: me.goodsId,
                                    num: 1
                                }
                            ],
                            orderType: 6
                        }).then(res => {
                            // 调整到支付页面
                            me.go("CartOrderPay", res.data);
                        });
                    });
                })
                .catch(() => {});
        }
    }
};
</script>

<style scoped lang="scss">
.scrollbar-container {
    background-color: #f7f8f8;
    .r10 {
        @include border-radius(10px);
    }
    .topImg {
        padding: 30px 30px 0 30px;
        height: 290px;
        background-image: url("~@/assets/imges/fee/vipPayTop.png");
        .vipPlaceholder {
            @include placeholder($font-size: 30px, $color: #eee);
        }
        .field {
            background-color: transparent;
            padding: 20px 0 12px 0;
            margin-bottom: 30px;
            border-bottom: solid 1px #fff;
            /deep/ .van-field__control {
                font-size: 60px;
                color: #fff;
            }
            /deep/ .van-field__clear {
                &:before {
                    background-image: url("~@/assets/imges/ico/clearfff.png");
                }
            }
        }
    }
    .list-container {
        padding: 0 30px 50px 30px;
        margin-top: -100px;
        .list {
            padding: 40px 40px 60px 40px;
            .title {
                padding: 0 0 29px 15px;
            }
            .list-item {
                flex: 0 0 50%;
                .item {
                    margin: 11px 15px;
                    .item-el {
                        padding: 50px 0;
                    }
                }
            }
            .btn-buy {
                @include border-radius(38px);
                margin-top: 49px;
                width: 510px;
                height: 76px;
            }
        }
    }
    .warning {
        color: #fff;
    }
}
[data-theme="app"] {
    .scrollbar-container {
        .topImg {
            background-image: url("~@/assets/imges/app/fee/vipPayTop.png");
        }
    }
}
</style>